import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { Article } from './style';

const RichTextSection = ({ data }) => {
  if (!data) return null;
  const {
    richTextHtml,
    colourOverrideBackground,
    colourOverrideText,
    anchorSlug,
  } = data;

  return (
    <Article
      id={anchorSlug}
      className="auto-margin"
      colourOverrideBackground={colourOverrideBackground}
      colourOverrideText={colourOverrideText}
    >
      {ReactHtmlParser(richTextHtml)}
    </Article>
  );
};

RichTextSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

RichTextSection.defaultProps = {};
export default RichTextSection;
